module.exports = __webpack_public_path__ + "img/delegate-cash-icon.b851a8e6.png";